/**
 * Response for GET billing/events/health.
 * Dead-letter + pending backlog signals for ops / metronome-sync tick watch.
 */
export class BillableEventsHealthResponse {
  deadLetterCount!: number;
  oldestDeadLetterAt!: string | null;
  pendingCount!: number;
  oldestPendingCreatedAt!: string | null;
  oldestPendingAgeSeconds!: number | null;
  stalePending!: boolean;
}
